import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BugTwoToneSvg from "@ant-design/icons-svg/es/asn/BugTwoTone";
import AntdIcon from "../components/AntdIcon";
var BugTwoTone = function BugTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BugTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BugTwoTone.displayName = 'BugTwoTone';
}
export default /*#__PURE__*/React.forwardRef(BugTwoTone);